// extracted by mini-css-extract-plugin
export default {"host":"host-module__host___UGZrK"};